export const getColorHash = (
  str: string,
  {
    saturation = 70,
    lightness = 50,
    alpha = 1,
  }: { saturation?: number; lightness?: number; alpha?: number } = {},
) => {
  let hash = 2166136267;

  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash *= 16777619;
    hash = hash >>> 0;
  }

  hash ^= hash >>> 16;
  hash *= 0x85ebca6b;
  hash ^= hash >>> 13;
  hash *= 0xc2b2ae35;
  hash ^= hash >>> 16;
  hash = hash >>> 0; // Ensure unsigned

  // Calculate hue (0-359)
  const hue = hash % 360;

  return `hsla(${hue}, ${saturation}%, ${lightness}%, ${alpha})`;
};
